"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateProps = exports.rerenderPropsList = void 0;
exports.rerenderPropsList = [
    'src',
    'name',
    'areaKeyName',
    'isMulti',
    'toggle',
    'active',
    'disabled',
    'fillColor',
    'strokeColor',
    'lineWidth',
    'imgWidth',
    'width',
    'height',
    'natural',
    'responsive',
    'parentWidth',
];
var imageMapperDefaultProps = {
    areaKeyName: 'id',
    isMulti: true,
    toggle: false,
    active: true,
    disabled: false,
    fillColor: 'rgba(255, 255, 255, 0.5)',
    strokeColor: 'rgba(0, 0, 0, 0.5)',
    lineWidth: 1,
    imgWidth: 0,
    width: 0,
    height: 0,
    natural: false,
    responsive: false,
    parentWidth: 0,
    containerProps: null,
    imgProps: null,
    canvasProps: null,
    mapProps: null,
    areaProps: null,
    onChange: null,
    onImageClick: null,
    onImageMouseMove: null,
    onClick: null,
    onMouseDown: null,
    onMouseUp: null,
    onTouchStart: null,
    onTouchEnd: null,
    onMouseMove: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onLoad: null,
};
var generateProps = function (props) {
    return Object.entries(imageMapperDefaultProps).reduce(function (acc, val) {
        var _a;
        var _b = val, key = _b[0], value = _b[1];
        // @ts-expect-error acc key error
        acc[key] = (_a = props[key]) !== null && _a !== void 0 ? _a : value;
        return acc;
    }, { src: props.src, name: props.name, areas: props.areas });
};
exports.generateProps = generateProps;
